import { Component } from '@angular/core';
import { ModalComponent } from '../../../../../models/modal-component';
import { OfflineMessageComponent } from '../../../../utils/offline-message/offline-message.component';

@Component({
    selector: 'app-offline-mode-modal',
    templateUrl: './offline-mode-modal.component.html',
    styleUrls: ['./offline-mode-modal.component.scss'],
    imports: [
        OfflineMessageComponent
    ],
    standalone: true
})
export class OfflineModeModalComponent extends ModalComponent {
    static MODAL_ID = 'offlineModal';

    getId(): string {
        return OfflineModeModalComponent.MODAL_ID;
    }
}
